<ng-container *ngIf="dialog$ | async as dialog">
    <div class="modal-header modal-header--import flex-column" [ngSwitch]="step">
      <div class="modal-title">Import - Slide Items</div>
      <div class="modal-subtitle mt-2" *ngSwitchCase="1">1. Import slide items from an excel file (Download <a [href]="files[0]" class="template">template</a>) <a class="template" (click)="onToggleReadMore()">{{readmore ? 'hide more': 'read more'}}</a></div>
      <div class="modal-subtitle mt-2" *ngSwitchCase="2">2. Add images to imported slide items</div>
      <button type="button" class="cursor-pointer" class="close close--paybee position-absolute" data-dismiss="modal" aria-label="Close" (click)="close(dialog, false)">
        <span class="cursor-pointer" aria-hidden="true">×</span>
      </button>
      <div class="readmore mt-2" *ngIf="readmore">
        <div class="mb-2">Support File Format: Excel with header row</div>
        <table width="750" border="2" cellpadding="5">
            <thead>
                <tr>
                    <td><b>Column Name</b></td>
                    <td><b>Required</b></td>
                    <td><b>Description</b></td>
                    <td><b>Note</b></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Item name</td>
                    <td>required</td>
                    <td>Name of the Item</td>
                    <td>Full Name of Item (127 characters max)</td>
                </tr>
                <tr>
                    <td>Image Url</td>
                    <td>optional</td>
                    <td>Name of the image file name</td>
                    <td>Full Name of Image File</td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
    <div class="modal-body" *ngIf="!closeButton" [ngSwitch]="step">
        <app-import-slide-xlsx
            *ngSwitchCase="1"
            [schema]="schema"
            [import]="import"
            [options]="options"
            (onChange)="onChangeOptions($event)"
        ></app-import-slide-xlsx>
        <app-import-images
            *ngSwitchCase="2"
            [options]="options"
            (onChange)="onChangeImages($event)"
            (onChangeFiles)="onChangeFiles($event)"
            (onChangeMissed)="onCgangeMissed($event)"
            [disabled]="isUploading"
        ></app-import-images>
    </div>
    <div class="modal-body" *ngIf="closeButton">
        <div *ngIf="closeButton" class="d-flex flex-column align-items-center my-5">
            <div>Successfully loaded {{options.length}} items.</div>
            <div>New items will appear at the bottom.</div>
        </div>
    </div>
    <div class="modal-footer modal-footer--import">
        <div class="d-flex justify-content-between w-100">
            <div class="col-8 d-flex align-items-center">
                <ng-container [ngSwitch]="step">
                    <ng-container *ngSwitchCase="1">
                        <div *ngIf="import.value" class="modal__found">{{options.length}} items, {{imageUrls}} image URLs, {{localImages}} local images found</div>
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                        <ng-container *ngIf="images.status === 0">
                            <div *ngIf="images.length > 0" class="modal__found">{{imageUrls}} image URLs, {{choosenImages.length}} local images found</div>
                        </ng-container>
                        <div *ngIf="images.status === 1" class="modal__found">
                            <span>Uploading... {{images.remaining}} images remaining...</span>
                            <img src="/img/gif/spinner-1s-200px.gif" height="38" width="38" /></div>
                        <div *ngIf="images.status === 2" class="modal__found">{{images.uploaded}} images successfully uploaded</div>
                    </ng-container>
                </ng-container>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-6">
                        <button
                            *ngIf="isNotFirstStep && !closeButton"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="goToPrevStep()"
                            [disabled]="prevStepDisabled"
                        >Previous</button>
                    </div>
                    <div class="col-6">
                        <button
                            *ngIf="nextStepDisplay"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="goToNextStep()"
                            [disabled]="nextStepDisabled"
                        >Next</button>
                        <button
                            *ngIf="upload && (images.length > 0 || hasLinks)"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onStart(dialog)"
                            [disabled]="nextStepDisabled"
                        >Upload</button>
                        <button
                            *ngIf="upload && images.length < 1 && !hasLinks"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onSkip(dialog)"
                        >Skip</button>
                        <button
                            *ngIf="confirm"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onConfirm(dialog)"
                        >Confirm</button>
                        <button
                            *ngIf="closeButton"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onClose(dialog)"
                        >Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </ng-container>
